import { Button } from '@service-victoria/component-library/components/Button';
import Page from '@service-victoria/component-library/components/Page';
import Text from '@service-victoria/component-library/components/Text';
import React from 'react';

import { constants } from 'app/utils';

import * as Styled from './styled';

const Maintenance = () => {
  const handleButton = () => {
    window.location.href = 'https://www.service.vic.gov.au';
  };

  return (
    <Page
      title={constants.RedemptionPage.title}
      breadCrumbs={constants.breadCrumbs}
      headerProps={constants.headerProps}
      showFooter>
      <Styled.Wrapper>
        <Styled.Content>
          <Text.Heading.H1 fontWeight='bold'>We&apos;re improving things</Text.Heading.H1>
          <Styled.Spacer24 />
          <Text.Heading.H3 fontWeight='bold'>
            The site&apos;s unavailable while we make a few small changes.
          </Text.Heading.H3>
          <Styled.Spacer12 />
          {window.CONFIG.signposting?.etaBackOnline ? (
            <Text.Body>Please try again after {window.CONFIG.signposting.etaBackOnline}.</Text.Body>
          ) : (
            <Text.Body>Please try again later.</Text.Body>
          )}
          <Styled.Spacer24 />
          <Button onClick={handleButton}>Back to home</Button>
        </Styled.Content>
      </Styled.Wrapper>
    </Page>
  );
};

export default Maintenance;
